<template>
  <section
    class="w-full gap-x-5 md:gap-x-8 lg:gap-x-12 2xl:gap-x-20 grid grid-cols-12 gap-y-10 lg:gap-y-[120px]"
  >
    <insight-card
      v-for="(insight, index) in insights"
      :key="insight.title"
      :image="insight.image"
      :imgAlt="insight.imgAlt"
      :date="insight.date"
      :title="insight.title"
      :tag="insight.tag"
      :isHorizontal="index === 0"
      :href="insight.href"
      :index="index"
      :theme="insight.theme"
      :classes="getCols(index)"
    />
  </section>
</template>

<script setup lang="ts">
import { toRefs } from "vue";
import { Theme } from "@/types/types";
import InsightCard from "@molecules/InsightCard/InsightCard.vue";

export interface IInsight {
  image: string;
  imgAlt: string;
  date: string;
  title: string;
  href: string;
  tag: string;
  theme?: Theme | null;
}

export interface IInsightsProps {
  insights?: IInsight[];
  classes?: string;
}

const props = defineProps<{ insights: IInsight[]; classes?: string }>();

const { insights, classes } = toRefs(props);

function getCols(index: number) {
  // Adjust index to align with the pattern starting at 1
  if (index === 0) {
    return "col-span-12 overflow-hidden";
  }
  const patternIndex = index % 8;

  // Large items aligned to the right
  if (patternIndex === 2 || patternIndex === 6) {
    return "col-span-12 md:col-span-6 md:col-start-7 overflow-hidden";
  }
  if (patternIndex === 3 || patternIndex === 7) {
    return "col-span-12 md:col-span-6 overflow-hidden";

    // Narrow items aligned to the right
  } else if (patternIndex === 4 || patternIndex === 0) {
    return "col-span-12 md:col-span-5  md:col-start-8 overflow-hidden";
    // Narrow items
  } else if (patternIndex === 5 || patternIndex === 0 || patternIndex === 1) {
    return "col-span-12 md:col-span-5 overflow-hidden";
  }
}
</script>
